<template>
    <div class="container my-auto">
        <v-row justify="center">
            <v-col md="12"> </v-col>
            <v-col class="letter-size text-center" cols="12">
                <v-icon size="150" color="primary"
                    >mdi-format-page-break</v-icon
                >
                Error 404
            </v-col>
            <v-col cols="8" class="text-center">
                <p class="letter-size-2">Page not found</p>
                <p>
                    This Page you are lookin for doesn't exist or another error
                    occurred.
                </p>
                <p>
                    <v-btn text @click="$router.go(-1)" color="primary"
                        >Go back</v-btn
                    >
                </p>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {};
</script>

<style>
.letter-size {
    font-size: 80px;
}
.letter-size-2 {
    font-size: 40px;
}
</style>
